import { QUESTION_TYPES } from '../../../constants/props';

export default name => {
  switch (name) {
    case QUESTION_TYPES.comment: {
      return 'text--comment';
    }
    default:
      return '';
  }
};



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/utils/getQuestionStyleName.js